import { httpClient } from './httpClient';
// Servicio para gestionar la bitácora de visitas
const base = '/api/bitacora';

export const listarVisitas = (params = {}) => {
  const query = params.fecha ? `?fecha=${encodeURIComponent(params.fecha)}` : '';
  return httpClient.get(`${base}${query}`);
};
export const registrarVisita = (payload) => httpClient.post(base, payload);
export const obtenerVisita = (id) => httpClient.get(`${base}/${id}`);
export const actualizarVisita = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const registrarSalida = (id) => httpClient.put(`${base}/${id}/salida`);
export const eliminarVisita = (id) => httpClient.del(`${base}/${id}`);

export const agregarNovedad = ({ bitacora_id, novedad_id }) =>
  httpClient.post(`${base}/novedad`, { bitacora_id, novedad_id });

export const listarNovedades = (bitacora_id) =>
  httpClient.get(`${base}/${bitacora_id}/novedades`);

const bitacoraService = {
  listar: listarVisitas,
  crear: registrarVisita,
  detalle: obtenerVisita,
  actualizar: actualizarVisita,
  salida: registrarSalida,
  eliminar: eliminarVisita,
  agregarNovedad,
  listarNovedades,
};

export default bitacoraService;
